<template>
  <div class="row">
    <div class="col-md-8 col-lg-6">
      <h5 class="mb-2">Реквизиты и контактные данные</h5>

      <ui-input-box-floating class="mb-3" :error="errors['LPName']">
        <ui-input
          v-model="props.data.LPName"
          type="text"
          placeholder="Наименование"
          :disabled="disabled"
        />
        <ui-input-label>Наименование</ui-input-label>
      </ui-input-box-floating>

      <div class="row">
        <div :class="{ 'col-md-12': fl, 'col-md-6': !fl }">
          <ui-input-box-floating class="mb-3" :error="errors['LPINN']">
            <ui-input
              v-model="props.data.LPINN"
              type="text"
              placeholder="ИНН"
              disabled
            />
            <ui-input-label>ИНН</ui-input-label>
          </ui-input-box-floating>
        </div>

        <div v-if="!fl" class="col-md-6">
          <ui-input-box-floating class="mb-3" :error="errors['LPKPP']">
            <ui-input
              v-model="props.data.LPKPP"
              type="text"
              placeholder="КПП"
              :disabled="disabled"
            />
            <ui-input-label>КПП</ui-input-label>
          </ui-input-box-floating>
        </div>
      </div>

      <Autocomplete
        class="mb-3"
        v-model="props.data.AddressFact"
        type="address"
        label="Фактический адрес"
        placeholder="Введите адрес"
        :error="errors['AddressFact']"
        :disabled="disabled"
        @select="(d) => (props.data.AddressFact = d.value)"
      />

      <ui-input-box-floating class="mb-3" :error="errors['OGRN']">
        <ui-input
          v-model="props.data.OGRN"
          type="text"
          placeholder="ОГРН"
          :disabled="disabled"
        />
        <ui-input-label>ОГРН</ui-input-label>
      </ui-input-box-floating>

      <ui-input-box-floating class="mb-3" :error="errors['OKPO']">
        <ui-input
          v-model="props.data.OKPO"
          type="text"
          placeholder="ОКПО"
          :disabled="disabled"
        />
        <ui-input-label>ОКПО</ui-input-label>
      </ui-input-box-floating>

      <div class="row">
        <div class="col-md-6">
          <ui-input-box-floating class="mb-3" :error="errors['RegDate']">
            <ui-input
              v-model="props.data.RegDate"
              placeholder="Дата регистрации"
              type="date"
              :disabled="disabled"
            />
            <ui-input-label>Дата регистрации</ui-input-label>
          </ui-input-box-floating>
        </div>

        <div class="col-md-6">
          <ui-input-box-floating class="mb-3" :error="errors['StartDate']">
            <ui-input
              v-model="props.data.StartDate"
              placeholder="Дата начала работы"
              type="date"
              :disabled="disabled"
            />
            <ui-input-label>Дата начала работы</ui-input-label>
          </ui-input-box-floating>
        </div>
      </div>

      <ui-input-box-floating class="mb-3" :error="errors['EmployeesNumber']">
        <ui-input
          v-model="props.data.EmployeesNumber"
          type="text"
          placeholder="Кол-во сотрудников"
          :disabled="disabled"
        />
        <ui-input-label>Кол-во сотрудников</ui-input-label>
      </ui-input-box-floating>

      <ui-input-box-floating class="mb-3" :error="errors['DocType']">
        <select
          class="form-control form-select"
          v-model="props.data.DocType"
          :disabled="disabled"
        >
          <option value="Устав">Устав</option>
          <option value="Доверенность">Доверенность</option>
          <option value="Договор">Договор</option>
          <option value="Свид-во ЕГРИП за ОГРНИП">
            Свид-во ЕГРИП за ОГРНИП
          </option>
        </select>
        <label>Вид документа-основания</label>
      </ui-input-box-floating>

      <div class="row">
        <div class="col-md-6">
          <ui-input-box-floating class="mb-3" :error="errors['DocNumber']">
            <ui-input
              v-model="props.data.DocNumber"
              type="text"
              placeholder="Номер документа"
              :disabled="disabled"
            />
            <ui-input-label>Номер документа</ui-input-label>
          </ui-input-box-floating>
        </div>

        <div class="col-md-6">
          <ui-input-box-floating class="mb-3" :error="errors['DocDate']">
            <ui-input
              v-model="props.data.DocDate"
              type="date"
              placeholder="Дата документа"
              :disabled="disabled"
            />
            <ui-input-label>Дата документа</ui-input-label>
          </ui-input-box-floating>
        </div>
      </div>

      <ui-input-box-floating class="mb-3" :error="errors['WebSite']">
        <ui-input
          v-model="props.data.WebSite"
          type="text"
          placeholder="Web-сайт"
          :disabled="disabled"
        />
        <ui-input-label>Web-сайт</ui-input-label>
      </ui-input-box-floating>

      <ui-input-box-floating class="mb-3" :error="errors['Phone']">
        <ui-input
          v-model="props.data.Phone"
          type="text"
          placeholder="Телефон организации-лизингополучателя"
          :disabled="disabled"
        />
        <ui-input-label>Телефон организации-лизингополучателя</ui-input-label>
      </ui-input-box-floating>

      <ui-input-box-floating class="mb-3" :error="errors['LPEmail']">
        <ui-input
          v-model="props.data.LPEmail"
          type="text"
          placeholder="E-mail организации-лизингополучателя"
          :disabled="disabled"
        />
        <ui-input-label>E-mail организации-лизингополучателя</ui-input-label>
      </ui-input-box-floating>
    </div>
    <div class="col-md-8 col-lg-6">
      <h5 class="mb-2">Данные руководителя</h5>

      <Autocomplete
        class="mb-3"
        v-model="props.data.DirectorLName"
        type="fio"
        label="Фамилия руководителя"
        :payload="{ parts: ['SURNAME'] }"
        placeholder="Фамилия руководителя"
        :error="errors['DirectorLName']"
        :disabled="disabled"
        @select="(d) => (props.data.DirectorLName = d.value)"
      />

      <div class="row">
        <div class="col-md-6">
          <!-- <ui-input-box-floating class="mb-3" :error="errors['DirectorFName']">
                        <ui-input v-model="props.data.DirectorFName" type="text" placeholder="Имя руководителя"
                            :disabled="disabled" />
                        <ui-input-label>Имя руководителя</ui-input-label>
                    </ui-input-box-floating> -->

          <Autocomplete
            class="mb-3"
            v-model="props.data.DirectorFName"
            type="fio"
            label="Имя руководителя"
            :payload="{ parts: ['NAME'] }"
            placeholder="Имя руководителя"
            :error="errors['DirectorFName']"
            :disabled="disabled"
            @select="(d) => (props.data.DirectorFName = d.value)"
          />
        </div>

        <div class="col-md-6">
          <!-- 
                    <ui-input-box-floating class="mb-3" :error="errors['DirectorMName']">
                        <ui-input v-model="props.data.DirectorMName" type="text" placeholder="Отчество руководителя"
                            :disabled="disabled" />
                        <ui-input-label>Отчество руководителя</ui-input-label>
                    </ui-input-box-floating> -->

          <Autocomplete
            class="mb-3"
            v-model="props.data.DirectorMName"
            type="fio"
            label="Отчество руководителя"
            :payload="{ parts: ['PATRONYMIC'] }"
            placeholder="Отчество руководителя"
            :error="errors['DirectorMName']"
            :disabled="disabled"
            @select="(d) => (props.data.DirectorMName = d.value)"
          />
        </div>

        <div class="col-md-6">
          <ui-input-box-floating class="mb-3" :error="errors['DirectorBD']">
            <ui-input
              v-model="props.data.DirectorBD"
              placeholder="Дата рождения руководителя"
              type="date"
              :disabled="disabled"
            />
            <ui-input-label>Дата рождения руководителя</ui-input-label>
          </ui-input-box-floating>
        </div>

        <div class="col-md-6">
          <ui-input-box-floating
            class="mb-3"
            :error="errors['DirectorPosition']"
          >
            <ui-input
              v-model="props.data.DirectorPosition"
              type="text"
              placeholder="Должность руководителя"
              :disabled="disabled"
            />
            <ui-input-label>Должность руководителя</ui-input-label>
          </ui-input-box-floating>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-auto">
          <h5>Данные подписанта</h5>
        </div>
        <div class="col-auto">
          <ui-button
            @click="copySigner"
            class="btn-base btn-small"
            :disabled="disabled"
            >Скопировать данные руководителя</ui-button
          >
        </div>
      </div>

      <!-- <ui-input-box-floating class="mb-3" :error="errors['SignerLName']">
                <ui-input v-model="props.data.SignerLName" type="text" placeholder="Фамилия подписанта"
                    :disabled="disabled" />
                <ui-input-label>Фамилия подписанта</ui-input-label>
            </ui-input-box-floating> -->

      <Autocomplete
        class="mb-3"
        v-model="props.data.SignerLName"
        type="fio"
        label="Фамилия подписанта"
        :payload="{ parts: ['SURNAME'] }"
        placeholder="Фамилия подписанта"
        :error="errors['SignerLName']"
        :disabled="disabled"
        @select="(d) => (props.data.SignerLName = d.value)"
      />

      <div class="row">
        <div class="col-md-6">
          <!-- <ui-input-box-floating class="mb-3" :error="errors['SignerFName']">
                        <ui-input v-model="props.data.SignerFName" type="text" placeholder="Имя подписанта"
                            :disabled="disabled" />
                        <ui-input-label>Имя подписанта</ui-input-label>
                    </ui-input-box-floating> -->

          <Autocomplete
            class="mb-3"
            v-model="props.data.SignerFName"
            type="fio"
            label="Имя подписанта"
            :payload="{ parts: ['NAME'] }"
            placeholder="Имя подписанта"
            :error="errors['SignerFName']"
            :disabled="disabled"
            @select="(d) => (props.data.SignerFName = d.value)"
          />
        </div>

        <div class="col-md-6">
          <!-- <ui-input-box-floating class="mb-3" :error="errors['SignerMName']">
                        <ui-input v-model="props.data.SignerMName" type="text" placeholder="Отчество подписанта"
                            :disabled="disabled" />
                        <ui-input-label>Отчество подписанта</ui-input-label>
                    </ui-input-box-floating> -->

          <Autocomplete
            class="mb-3"
            v-model="props.data.SignerMName"
            type="fio"
            label="Отчество подписанта"
            :payload="{ parts: ['PATRONYMIC'] }"
            placeholder="Отчество подписанта"
            :error="errors['SignerMName']"
            :disabled="disabled"
            @select="(d) => (props.data.SignerMName = d.value)"
          />
        </div>

        <div class="col-md-6">
          <ui-input-box-floating class="mb-3" :error="errors['SignerBD']">
            <ui-input
              v-model="props.data.SignerBD"
              placeholder="Дата рождения подписанта"
              type="date"
              :disabled="disabled"
            />
            <ui-input-label>Дата рождения подписанта</ui-input-label>
          </ui-input-box-floating>
        </div>

        <div class="col-md-6">
          <ui-input-box-floating class="mb-3" :error="errors['SignerPosition']">
            <ui-input
              v-model="props.data.SignerPosition"
              type="text"
              placeholder="Должность подписанта"
              :disabled="disabled"
            />
            <ui-input-label>Должность подписанта</ui-input-label>
          </ui-input-box-floating>
        </div>

        <div class="col-md-6">
          <ui-input-box-floating class="mb-3" :error="errors['SignerPhone']">
            <ui-input
              v-model="props.data.SignerPhone"
              type="text"
              placeholder="Телефон подписанта"
              :disabled="disabled"
            />
            <ui-input-label>Телефон подписанта</ui-input-label>
          </ui-input-box-floating>
        </div>

        <div class="col-md-6">
          <ui-input-box-floating class="mb-3" :error="errors['SignerEmail']">
            <ui-input
              v-model="props.data.SignerEmail"
              type="text"
              placeholder="E-mail подписанта"
              :disabled="disabled"
            />
            <ui-input-label>E-mail подписанта</ui-input-label>
          </ui-input-box-floating>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-auto">
          <h5>Данные контактного лица</h5>
        </div>
        <div class="col-auto">
          <ui-button
            @click="copyContact"
            class="btn-base btn-small"
            :disabled="disabled"
            >Скопировать данные руководителя</ui-button
          >
        </div>
      </div>

      <!-- <ui-input-box-floating class="mb-3" :error="errors['ContactLName']">
                <ui-input v-model="props.data.ContactLName" type="text" placeholder="Фамилия контактного лица"
                    :disabled="disabled" />
                <ui-input-label>Фамилия контактного лица</ui-input-label>
            </ui-input-box-floating> -->

      <Autocomplete
        class="mb-3"
        v-model="props.data.ContactLName"
        type="fio"
        label="Фамилия контактного лица"
        :payload="{ parts: ['SURNAME'] }"
        placeholder="Фамилия контактного лица"
        :error="errors['ContactLName']"
        :disabled="disabled"
        @select="(d) => (props.data.ContactLName = d.value)"
      />

      <div class="row">
        <div class="col-md-6">
          <!-- <ui-input-box-floating class="mb-3" :error="errors['ContactFName']">
                        <ui-input v-model="props.data.ContactFName" type="text" placeholder="Имя контактного лица"
                            :disabled="disabled" />
                        <ui-input-label>Имя контактного лица</ui-input-label>
                    </ui-input-box-floating> -->

          <Autocomplete
            class="mb-3"
            v-model="props.data.ContactFName"
            type="fio"
            label="Имя контактного лица"
            :payload="{ parts: ['NAME'] }"
            placeholder="Имя контактного лица"
            :error="errors['ContactFName']"
            :disabled="disabled"
            @select="(d) => (props.data.ContactFName = d.value)"
          />
        </div>

        <div class="col-md-6">
          <!-- <ui-input-box-floating class="mb-3" :error="errors['ContactMName']">
                        <ui-input v-model="props.data.ContactMName" type="text" placeholder="Отчество контактного лица"
                            :disabled="disabled" />
                        <ui-input-label>Отчество контактного лица</ui-input-label>
                    </ui-input-box-floating> -->

          <Autocomplete
            class="mb-3"
            v-model="props.data.ContactMName"
            type="fio"
            label="Отчество контактного лица"
            :payload="{ parts: ['PATRONYMIC'] }"
            placeholder="Отчество контактного лица"
            :error="errors['ContactMName']"
            :disabled="disabled"
            @select="(d) => (props.data.ContactMName = d.value)"
          />
        </div>

        <div class="col-md-6">
          <ui-input-box-floating class="mb-3" :error="errors['ContactBD']">
            <ui-input
              v-model="props.data.ContactBD"
              placeholder="Дата рождения контактного лица"
              type="date"
              :disabled="disabled"
            />
            <ui-input-label>Дата рождения контактного лица</ui-input-label>
          </ui-input-box-floating>
        </div>

        <div class="col-md-6">
          <ui-input-box-floating
            class="mb-3"
            :error="errors['ContactPosition']"
          >
            <ui-input
              v-model="props.data.ContactPosition"
              type="text"
              placeholder="Должность контактного лица"
              :disabled="disabled"
            />
            <ui-input-label>Должность контактного лица</ui-input-label>
          </ui-input-box-floating>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Autocomplete from "../../../component/Autocomplete/index.vue";

const props = defineProps({
  data: {
    type: Object,
    default: {},
  },
  fl: {
    type: Boolean,
    default: true,
  },
  errors: {
    type: Object,
    default: {},
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const copySigner = () => {
  props.data.SignerLName = props.data.DirectorLName;
  props.data.SignerFName = props.data.DirectorFName;
  props.data.SignerMName = props.data.DirectorMName;
  props.data.SignerBD = props.data.DirectorBD;
  props.data.SignerPosition = props.data.DirectorPosition;
};

const copyContact = () => {
  props.data.ContactLName = props.data.DirectorLName;
  props.data.ContactFName = props.data.DirectorFName;
  props.data.ContactMName = props.data.DirectorMName;
  props.data.ContactBD = props.data.DirectorBD;
  props.data.ContactPosition = props.data.DirectorPosition;
};
</script>